import { selectors } from '../../../state';
import { menuItems, isSignedIn } from './mover-dropdown.items';
import template from './mover-dropdown.html';
import './mover-dropdown.global.css';
import { track, TRACK } from '@updater-core/lib/tracker';

class MoverDropdownController {
  constructor(updStore, appShell, $element) {
    'ngInject';
    Object.assign(this, { updStore, appShell, $element });

    this._menuId = Math.random();
  }

  get menuId() {
    return this._menuId;
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  onSignOut(event) {
    event.preventDefault();

    // This HALT action will stop the redux store, preventing any further
    // actions from triggering a state change. This is a special action
    // to be used only when we want to stop the store and unmount the Mover App.
    this.updStore.dispatch({ type: 'HALT' });
    const sessionState = this.appShell.interactors.session.getState();
    this.appShell.interactors.session.actions
      .clearSession(sessionState)
      .then(() => {
        track({
          verb: TRACK,
          object: 'signout',
        });
        this.appShell.interactors.router.go('/sign-in');
      });
  }

  goToSignIn(event) {
    event.preventDefault();
    this.appShell.interactors.router.go('/sign-in');
  }
}

function mapStateToThis(state) {
  const user = selectors.current.user(state);
  const moves = (user.moves(state) || []).map((move) => move.identity(state));
  const mover = { ...user.identity(state), moves };

  const ret = {
    isSignedIn: isSignedIn(mover),
    menuItems: menuItems(mover).filter((item) => item.show),
    mover,
    title: mover.id ? `Hi ${mover.first_name}` : 'Sign In',
  };
  return ret;
}

export const MoverDropdownComponent = {
  controller: MoverDropdownController,
  template,
};
